import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

export const mapFields = (data: ModuleFields[]) =>
  data.map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, options, hidden, loadOptions, uploadTrigger, note }) => ({
    name,
    type: formType,
    label: fieldName,
    placeholder,
    validation,
    className,
    options,
    hidden,
    usedFileType,
    loadOptions,
    uploadTrigger,
    note
  }));

export const fields: any = {
  parentHeader: mapFields(drilldownData['parentHeader']),
  childHeader: mapFields(drilldownData['childHeader']),
  grandChildHeader: mapFields(drilldownData['grandChildHeader'])
};
